import { render, staticRenderFns } from "./DeviceRegistrationFilter.vue?vue&type=template&id=13636428&"
import script from "./DeviceRegistrationFilter.vue?vue&type=script&lang=js&"
export * from "./DeviceRegistrationFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports